var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSym(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M199.495,104.365 C179.902,115.667 154.849,108.960 143.537,89.385 C132.225,69.810 138.938,44.779 158.531,33.478 C178.124,22.176 203.177,28.883 214.489,48.458 C225.801,68.033 219.088,93.063 199.495,104.365 ZM160.943,171.079 C160.943,193.682 142.603,212.005 119.979,212.005 C97.355,212.005 79.014,193.682 79.014,171.079 C79.014,148.475 97.355,130.152 119.979,130.152 C142.603,130.152 160.943,148.475 160.943,171.079 ZM40.462,104.365 C20.869,93.063 14.156,68.033 25.468,48.458 C36.780,28.883 61.833,22.176 81.426,33.478 C101.019,44.779 107.732,69.810 96.420,89.385 C85.108,108.960 60.055,115.667 40.462,104.365 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSym);
export default __webpack_public_path__ + "static/media/Sym.d69033dfd53c8c72cb50ae8e7865c770.svg";
export { ForwardRef as ReactComponent };